"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { takeDisabledSessionNotice } from "@/utils/disabledSession";
const initialState = {};
export const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SUCCESS_TOAST":
      toast.success(action.payload.message, action.payload.options);
      return state;
    case "WARN_TOAST":
      toast.warn(action.payload.message, action.payload.options);
      return state;
    case "FAIL_TOAST":
      toast.error(action.payload.message, action.payload.options);
      return state;
    case "INFO_TOAST":
      toast.info(action.payload.message, action.payload.options);
      return state;
    case "NOTIFICATION":
      toast(action.payload.message.text, action.payload.options);
      return state;
    default:
      return state;
  }
};
export const showToast = (message, type, handleRedirect = null) => {
  const options = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    ...(handleRedirect ? {
      onClick: () => handleRedirect(message)
    } : {})
  };
  return {
    type,
    payload: {
      message,
      options
    }
  };
};
export const ToastifyContainer = t0 => {
  const $ = _c(2);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToastContainer />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
function _temp() {
  const message = takeDisabledSessionNotice();
  if (message) {
    toast.error(message, {
      toastId: "account-disabled"
    });
  }
}